.md3.switch {
  user-select: none;
  position: relative;
  -webkit-tap-highlight-color: transparent;
  margin: 10px;
  font-family: var(--font-family);
}

.md3.switch input {
  opacity: 0;
  width: 0;
  height: 0;
  margin: 0;
  padding: 0;
}

.md3.switch span.slider {
  position: absolute;
  cursor: pointer;
  background-color: var(--color-primary-container);
  width: 48px;
  height: 28px;
  border-radius: 28px;
  border: 2px solid var(--color-outline);
  transition: background-color 0.1s ease-in-out, border-color 0.1s ease-in-out;
}

/* thumb */
.md3.switch span.slider::before {
  position: absolute;
  content: '';
  height: 16px;
  width: 16px;
  left: 0px;
  margin: 6px;
  background-color: var(--color-outline);
  border-radius: 28px;
  transition: left 175ms cubic-bezier(0, 0.5, 0.5, 1.5), background-color 0.1s ease-in-out, height 50ms ease-in-out, width 50ms ease-in-out, margin 50ms ease-in-out;
}

.md3.switch span.slider span.icon {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  left: 0px;
  margin: 6px 0px;
  height: 16px;
  width: 16px;
  font-size: 16px;
  text-align: center;
  opacity: 0;
  transition: left 175ms cubic-bezier(0, 0.5, 0.5, 1.5);
  color: var(--color-surface-variant);
}

.md3.switch input:checked + span.slider {
  background-color: var(--color-primary);
  border-color: transparent;
}

.md3.switch input:checked + span.slider::before {
  background-color: var(--color-on-primary);
  height: 24px;
  width: 24px;
  left: 20px;
  margin: 2px;
}

.md3.switch input:not(:disabled):hover + span.slider::before {
  background-color: var(--color-on-surface-variant);
}

.md3.switch input:not(:disabled):checked:hover + span.slider::before {
  background-color: var(--color-primary-container);
}

.md3.switch input:not(:disabled):active + span.slider::before {
  height: 28px;
  width: 28px;
  margin: 0px;
}

.md3.switch input:not(:disabled):checked:active + span.slider::before {
  background-color: var(--color-primary-container);
}

.md3.switch input:checked + span.slider span.icon {
  left: 26px;
  opacity: 1;
  color: var(--color-on-primary-container);
}

.md3.switch input:focus-visible + span.slider {
  outline: 2px solid var(--color-primary);
}
